/**
 * 权限控制类库，提供权限检查函数
 * 权限数据由后端加载提供
 */
import router from '@/router';
import store from '@/store';
import { source } from '@/store/home';

/**
 * 根据资源id和路由自动补全当前完整的资源ID
 * @return string
 */
export const getFullSourceID = (sourceid, rpath = router.currentRoute.path) => {
    rpath = rpath.split("/");
    rpath.shift();
    rpath = rpath.map(item => "*" + item).join(".");
    rpath += "." + sourceid;
    return rpath;
};

/**
 * authcheck 权限检查
 * @param {*} sourceid 单个功能点的权限名
 * @param {*} mainuser 功能点所属主账号，若不传，则检查系统的功能点
 * @param {*} auto_completion 是否自动补全ID，若为false，sourceid必须填写完整的才可以成功匹配
 * @returns
*/
export const authcheck = function (sourceid, mainuser = store.state.home.mainuser, auto_completion = true) {
    const source_id = auto_completion ? getFullSourceID(sourceid) : sourceid;
    const check_table = mainuser ? source.sourcelist[mainuser] : source.commonmenulist;

    // console.log('authcheck debug:', source_id, check_table, check_table.indexOf(source_id) > -1);

    return check_table.indexOf(source_id) > -1;
}

export default {
    install(Vue) {
        Vue.directive("auth", {
            bind(el, binding) {
                if (binding.modifiers && binding.modifiers.common) {
                    if (!authcheck(binding.value, false)) el.style.display = "none";
                } else {
                    if (!authcheck(binding.value)) el.style.display = "none";
                }
            }
        });

        window.authcheck = authcheck;
        Vue.prototype.authcheck = authcheck; // 添加实例方法
    }
}
